
import React from 'react';
import { UpcomingPaymentsPanel as PaymentsPanel } from '../payments/components/UpcomingPaymentsPanel';

// Реэкспортируем компонент из модуля payments
export const UpcomingPaymentsPanel = () => {
  return <PaymentsPanel />;
};
